import { useTranslation } from "react-i18next";
import type { ThemeClasses } from "../types";
import { GeofenceFilters } from "./GeofenceFilters";
import { GeofenceViewToggle } from "./GeofenceViewToggle";
import { useDisableCRUD } from "../../../../../../store/admin/companiesStore";
import useIsMonitor from "../../../../../../hooks/useIsMonitor";
import { CRUDTooltip } from "../../../../../../components/base/CRUDTooltip";

interface GeofenceHeaderProps {
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  selectedShape: string;
  selectedType: string;
  selectedStatus: string;
  searchQuery: string;
  selectedView: "grid" | "list";
  onShapeChange: (value: string) => void;
  onTypeChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onViewChange: (view: "grid" | "list") => void;
  onAddNew: () => void;
}

export function GeofenceHeader({
  themeClasses,
  isDarkMode,
  selectedShape,
  selectedType,
  selectedStatus,
  searchQuery,
  selectedView,
  onShapeChange,
  onTypeChange,
  onStatusChange,
  onSearchChange,
  onViewChange,
  onAddNew,
}: GeofenceHeaderProps) {
  const { t } = useTranslation("adminSections");
  const disableCRUD = useDisableCRUD();
  const { isMonitor, isReadOnly } = useIsMonitor();
  return (
    <div
      className={`${themeClasses.bg} border-b ${themeClasses.border} px-4 py-3 sm:px-6 sm:py-4`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mb-3">
        <div className="min-w-0">
          <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
            {t("geofences.title", "Gestión de Geocercas")}
          </h1>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
            {t(
              "geofences.subtitle",
              "Administra todas las zonas geográficas de control",
            )}
          </p>
        </div>
        {!isMonitor && !isReadOnly && (
          <CRUDTooltip className="self-start sm:self-auto flex-shrink-0">
            <button
              onClick={onAddNew}
              disabled={disableCRUD}
              className="bg-primary-500 hover:bg-primary-400 text-gray-900 px-3 sm:px-4 py-2 rounded-lg font-medium flex items-center justify-center space-x-2 transition-colors whitespace-nowrap text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i className="ri-add-line"></i>
              <span className="hidden sm:inline">
                {t("geofences.actions.new", "Nueva Geocerca")}
              </span>
              <span className="sm:hidden">
                {t("geofences.actions.newShort", "Nueva")}
              </span>
            </button>
          </CRUDTooltip>
        )}
      </div>

      <div className="flex items-center gap-2 min-w-0">
        <GeofenceFilters
          selectedShape={selectedShape}
          selectedType={selectedType}
          selectedStatus={selectedStatus}
          searchQuery={searchQuery}
          isDarkMode={isDarkMode}
          themeClasses={themeClasses}
          onShapeChange={onShapeChange}
          onTypeChange={onTypeChange}
          onStatusChange={onStatusChange}
          onSearchChange={onSearchChange}
        />

        <GeofenceViewToggle
          selectedView={selectedView}
          themeClasses={themeClasses}
          onViewChange={onViewChange}
        />
      </div>
    </div>
  );
}
